export default "__VITE_ASSET__Cpux6Ljt__"